import React, { FC } from "react";
import { CustomButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { IVisibilityButtonComponentProps } from "./types";

export const VisibilityButton: FC<IVisibilityButtonComponentProps> = ({ visible, toggleVisibility, disabled }) => {
  const { t } = useTranslation("layerList");

  return (
    <CustomButton
      title={visible ? t("hideFromMap") : t("showOnMap")}
      disabled={disabled}
      onClick={toggleVisibility}
      kinds={["password_show", "password_hide"]}
      isSelected={visible}
      primary={visible}
    />
  );
};
